import { combineReducers } from 'redux';
import AuthReducer from './authreducer';
import LoadOrderReducer from './LoadOrderReducer';
import LoadingReducer from './LoadingReducer';
import SearchOrderReducer from './SearchOrderReducer';
import LoadDeedReducer from './LoadDeedReducer';
import UserReducer from './UserReducer';
import OrderStatusReducer from './OrderStatusReducer';
import LoadOrderTitleReducer from './LoadOrderTitleReducer';
import SearchCompanyReducer from './SearchCompanyReducer';
import { reducer as formReducer } from "redux-form";
import AddCompanyReducer from './AddCompanyReducer';
import LoadCompanyProductReducer from './LoadCompanyProductReducer';
import LoadTaxReducer from './LoadTaxReducer';
export default combineReducers({
    session: AuthReducer,
    form: formReducer,
    loadOrder: LoadOrderReducer,
    loadDeed: LoadDeedReducer,
    loadTax: LoadTaxReducer,
    searchOrder : SearchOrderReducer,
    loading : LoadingReducer,
    User : UserReducer,
    OrderProductStatus : OrderStatusReducer,
    OrderTitle : LoadOrderTitleReducer,
    SearchCompany : SearchCompanyReducer,
    AddCompany : AddCompanyReducer,
    LoadCompanyProduct:LoadCompanyProductReducer

})